<template>
  <div class="career-filters" v-bind:style="{ backgroundImage: 'url(' + bg + ')' }">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="rel-header rel">
            <div class="abs-header">
              <p class="white no-mar"><a class="no-dec h-dec" v-bind:href="back">ironSource Careers</a>&nbsp;/&nbsp;{{title}}</p>
              <div class="inline-filter">
                <div class="placer-static">
                  <h3><label>{{cats}}<input readonly="true" id="cat-filter" @focus="catFocus = true" @blur="catsBlur($event)" type="text"></label>&nbsp;</h3>
                  <div class="collapsible" v-bind:class="{ open: (catFocus && filters.categories.length) }">
                    <ul>
                      <li v-on:click="resetFilter('categories')" class="capit">Anything</li>
                      <li v-on:click="addFilter('categories', filter, true)" v-bind:key="i" v-for="(filter, i) in filters.categories" v-html="filter"></li>
                    </ul>
                  </div>
                </div>
                <div class="dynamic">
                  <h3><label for="cat-filter"><span class="active-cat" v-html="catsLabel()"></span></label></h3>
                </div>
                <div class="drop"></div>
              </div>
              <div class="combo-box">
                <div class="flex sc_form roundbox">
                  <span class="capsule" v-on:click="addFilter('tags', tag, false)" v-for="(tag, i) in applied.tags"><span v-html="tag"></span>&nbsp;<em>&times;</em></span>
                  <div class="sc_form_item">
                    <input @focus="focus = true" @blur="searchBlur($event)" v-bind:placeholder="tags" v-on:input="debounceInput" type="text" class='inline'>
                  </div>
                </div>
                <div class="collapsible" v-bind:class="{ open: focus && searched }">
                  <div class="results" v-if="((found.tags && found.tags.length) || (found.jobs && found.jobs.length))">
                    <ul>
                      <li v-bind:key="i" v-for="(filter, i) in found.tags"><a v-on:click="addFilter('tags', filter, false); $event.preventDefault()" href="#"><svg><use xlink:href="#search"></use></svg><span v-html="filter"></span></a></li>
                    </ul>
                    <div v-if="(typeof found.jobs && found.jobs.length)" class="divider">Open positions</div>
                    <ul>
                      <li v-bind:key="i" v-for="(job, i) in found.jobs"><a target="_blank" v-bind:href="job.url"><svg><use xlink:href="#brief"></use></svg>{{job.title}}</a></li>
                    </ul>
                  </div>
                  <div class="empty"><svg><use xlink:href="#ghost"></use></svg>No results</div>
                </div>
                <svg class="abs-icon"><use xlink:href="#search"></use></svg>
              </div>
            </div>
          </div>
        </div>
      </div>  
    </div>
  </div>  
</template>

<script>
import { mapGetters } from 'vuex'
import debounce from 'debounce'

export default {
  name: 'CareerFilters',
  data: function() {
    return {
      searched: false,
      catFocus: false,
      focus: false,
      title: window.iron_careers.labels.title,
      back: window.iron_careers.back_url,
      bg: window.iron_careers.labels.bg,
    }
  },
  computed: {
    ...mapGetters({
      total: 'getTotal',
      found: 'getFound',
      filters: 'getFilters',
      applied: 'getApplied'
    }),
    cats: function() {
      return window.iron_careers.labels.categories
    },
    tags: function() {
      return (this.applied.tags && this.applied.tags.length) ? 'and..' : window.iron_careers.labels.tags
    }
  },
  methods: {
    catsLabel: function() {
      return (this.applied.categories && this.applied.categories.length) ? this.applied.categories[0] : 'anything'
    },
    resetFilter: function(type) {
      this.$store.dispatch('resetFilter', {type})
    },
    addFilter: function(type, filter, toggle) {
      this.$store.dispatch('applyFilter', {
        type,
        filter,
        toggle
      })
    },
    searchBlur: function(e) {
      e.target.value = ''
      this.focus = false
      this.searched = false
    },
    catsBlur: function(e) {
      this.catFocus = false
    },
    debounceInput: debounce(function (e) {
      this.searched = true
      this.$store.dispatch('searchTerm', e.target.value)
    }, '500')
  },
  mounted: function() {
    this.$store.dispatch('getFilters')
  }
}
</script>